import { Link } from 'react-router-dom';
import type { ClassInterface } from '../../../types/class.interface';
import { ClassTypeLabel } from '../../../components/classes/ClassTypeLabel';

interface RecommendedClassesProps {
  classes: ClassInterface[];
  isLoading?: boolean;
}

const formatClassForDisplay = (classItem: ClassInterface) => {
  const startTime = new Date(classItem.timeStamp || 0);
  const to2 = (n: number) => (n < 10 ? `0${n}` : `${n}`);
  const weekday = startTime.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric' });
  const hour = `${to2(startTime.getHours())}:${to2(startTime.getMinutes())}`;
  return {
    time: weekday,
    hour,
    name: classItem.title,
    studio: classItem.studio?.name || '',
    type: classItem.liveStreamClass ? 'ONLINE' : 'PRESENCIAL',
    img: classItem.studio?.image || '',
    slug: classItem.slug,
    timeStamp: classItem.timeStamp,
    studioImage: classItem.studio?.image ? 'https://image.beholos.com/fit-in/1200x750' + classItem.studio?.image : '',
  };
};

export function RecommendedClasses({ classes, isLoading }: RecommendedClassesProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        <span className="ml-2 text-gray-600">Cargando clases...</span>
      </div>
    );
  }

  if (!classes || classes.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <span className="text-gray-600">No hay clases disponibles para hoy</span>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm">
      {classes.map((classItem, idx) => {
        const classData = formatClassForDisplay(classItem);
        return (
          <div key={idx} className="flex items-center py-4 px-4 border-b border-gray-200 last:border-b-0">
            <div className="flex-grow flex items-center">
              <div className="text-xs mr-3 text-center">
                <div className="capitalize">{classData.time}</div>
                <div>{classData.hour}</div>
              </div>
              <div className="w-12 h-12 rounded-full bg-cover bg-center mx-3 md:mx-4 border border-gray-200" style={{ backgroundImage: `url("${classData.studioImage}")` }}></div>
              <div className="flex items-center">
                <div>
                  <div className="text-sm font-medium">{classData.name}</div>
                  <div className="text-gray-600 text-xs">{classData.studio}</div>
                  <div className="flex md:hidden mb-1">
                    <ClassTypeLabel liveStreamClass={!!classItem.liveStreamClass} />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div>
                <div className="hidden md:flex justify-end mb-1">
                  <ClassTypeLabel liveStreamClass={!!classItem.liveStreamClass} />
                </div>
                <Link
                  to={`/clases/${classItem.studio?.slug}/${classData.slug}/${classData.timeStamp}`}
                  className="rounded-sm bg-white text-holos-dark border border-holos-dark hover:bg-holos-light px-3 py-1 text-xs font-bold uppercase hidden md:inline-block"
                >
                  AGENDAR
                </Link>
              </div>
              <Link
                to={`/clases/${classItem.studio?.slug}/${classData.slug}/${classData.timeStamp}`}
                className="md:hidden text-holos-dark ml-3"
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
}


